import { Form } from 'antd';
import { Rule } from 'antd/es/form';
import { FormItemProps } from 'antd/lib';
import _ from 'lodash';
import * as React from 'react';
import * as yup from 'yup';

yup.setLocale({
  number: {
    min: ({ min }) => `Giá trị phải lớn hơn hoặc bằng ${min}.`,
    max: ({ max }) => `Giá trị phải nhỏ hơn hoặc bằng ${max}.`,
    integer: 'Giá trị phải là số nguyên',
  },
  string: {
    min: ({ min }) => `Độ dài phải lớn hơn hoặc bằng ${min} ký tự.`,
    max: ({ max }) => `Độ dài phải nhỏ hơn hoặc bằng ${max} ký tự.`,
    matches: ({ regex }) => `Định dạng không hợp lệ. Định dạng yêu cầu: ${regex}.`,
    trim: 'Giá trị không được bắt đầu hoặc kết thúc bằng dấu cách',
  },
  date: {
    max: ({ max }) => `Ngày không được sau ${max}.`,
    min: ({ min }) => `Ngày không được trước ${min}.`,
  },
});

export interface IEmrFormItemProps extends FormItemProps {
  field?: IFieldConfig;
  ref?: any;
}

const EmrFormItem: React.FC<IEmrFormItemProps> = ({
  field,
  children,
  label,
  ref,
  required,
  valuePropName,
  ...props
}) => {
  const mainLabel = typeof label === 'string' ? label : field?.label;
  const rules: Rule[] = [{ required: typeof required === 'boolean' ? required : field?.required }];

  const formContext = Form.useFormInstance();

  //   try {
  //     // eslint-disable-next-line react-hooks/rules-of-hooks
  //     formContext = Form.useFormInstance();
  //   } catch (_) {
  //     // No handler
  //   }

  if (field?.extra.validatorFn) {
    rules.push({
      async validator(rule, value) {
        return await field?.extra?.validatorFn?.(rule, value, yup);
      },
    });
  }
  if (field?.extra?.validator) {
    rules.push({
      async validator(rule, value) {
        return await validatorHandler(field, value);
      },
    });
  }

  // Helper to render children
  const renderChildren = typeof children === 'function' ? (children as Function)() : children;

  if (formContext) {
    return (
      <Form.Item rules={rules} {...props} label={mainLabel}>
        {renderChildren}
      </Form.Item>
    );
  } else {
    return (
      <div className="p-4">
        {mainLabel && <div className="mb-2">{mainLabel}:</div>}
        {renderChildren}
      </div>
    );
  }
};
export default EmrFormItem;

const validatorHandler = async (field: IFieldConfig, value: any) => {
  let validator: any;

  switch (field.type) {
    case 'string':
      validator = yup.string();
      break;
    case 'number':
      validator = yup.number();
      break;
    case 'date':
      validator = yup.date();
      console.log('DATE');
      break;
    default:
      return;
  }
  validator = validator.nullable();

  Object.keys(field.extra.validator || {}).forEach((k) => {
    let v = field.extra.validator?.[k];

    if (v === undefined) return;

    v = _.isArray(v) ? v : [v];

    switch (k) {
      case 'min':
        validator = validator.min?.(v[0], v[1]);
        break;
      case 'max':
        validator = validator.max?.(v[0], v[1]);
        break;
      case 'integer':
        validator = validator.integer?.(v[0], v[1]);
        break;
      case 'trim':
        if (v[0]) {
          validator = validator.test(
            'no-trailing-whitespace',
            v[1] || 'Giá trị không được bắt đầu hoặc kết thúc bằng dấu cách',
            (value: string) => {
              return value === value?.trim() || value === undefined;
            },
          );
        }
        break;
      case 'matches':
        validator = validator.matches && validator.matches(v[0], v[1]);
        break;
      default:
        break;
    }
  });
  return await validator.validateSync(value === '' ? undefined : value);
};
